export const COLORS: any = {
  player: '#1D203D',
  disabled: '#eee',
  healthy: '#cecfd6',
  closeContact: '#cecfd6',
  infected: '#FFE057',
  infectious: '#F77635',
  symptomatic: '#EF555C',
  quarantinedInfectious: '#F77635',
  quarantinedInfectious2: '#F77635',
  quarantinedSymtomatic: '#EF555C',
  quarantinedInfected: '#FFE057',
  quarantinedHealthy: '#cecfd6',
  quarantined: '#ebecf0',
  bg: '#ffffff',
  home: '#f9f6f6',
  quarantine: '#8c8c91'
}
